define([
 "./moveTripsToUserModule",
 "./moveTripsToUserModal"
 ], function () {
});